package com.schoolconnect.app.feature.imports

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember

@Composable
fun ImportsFeatureRoute(
    schoolCode: String = "",
    schoolId: String = ""
) {
    val viewModel = remember(schoolCode, schoolId) {
        ImportsViewModel(schoolCode = schoolCode, schoolId = schoolId)
    }
    val uiState by viewModel.uiState.collectAsState()

    DisposableEffect(viewModel) {
        onDispose { viewModel.clear() }
    }

    ImportsScreen(
        state = uiState,
        onEvent = viewModel::onEvent
    )
}
